import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom'

// components
import AppCard from '../../components/AppCard'
import AppForm from '../../components/form/form-game/AppForm'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'
import AppModalConfirmation from '../../components/modal/AppModalConfirmation'

// helpers
import Axios from '../../helpers/axios'

const AddGame = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const isLoading = useSelector((state) => state.isLoading)

  const [showModalConfirm, setShowModalConfirm] = useState({ show: false })

  const formik = useFormik({
    initialValues: {
      game_game_name: '',
      game_is_active: false,
    },
    validationSchema: Yup.object().shape({
      game_game_name: Yup.string()
        .required("Please enter game name."),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  const handleInputValue = (values) => {
    let data = {
      game_name: values.game_game_name,
      is_active: values.game_is_active,
    }

    return data
  }

  const handlePost = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: `/api/gamepass/v1/game/create`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          navigate('/game/list')
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  const handleSubmit = () => {
    formik.handleSubmit()

    setShowModalConfirm({ show: false })
  }

  const handleSwitch = (e, name) => {
    let checked = e.target.checked

    formik.setValues((prevValues) => ({
      ...prevValues,
      [name]: checked
    }), false)
  }

  return (
    <>
      {
        showModalConfirm.show && (
          <AppModalConfirmation 
            confirmationType="confirmation"
            showModal={showModalConfirm}
            setShowModal={setShowModalConfirm}
            headerTitle="Confirmation"
            descriptionText="Are you sure want create a new game?"
            handleSubmit={handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
          />
        )
      }
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Add Game</h4>}
        bodyContent={
          <AppForm 
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            handleSwitch={handleSwitch}
          />
        }
        footerContent={
          <ActionButtonForm
            isLoading={isLoading}
            disabled={formik.isSubmitting}
            onCancel={() => navigate('/game/list')}
            onSave={() => setShowModalConfirm({ show: true })}
          />
        }
      />
    </>
  )
}

export default AddGame